<div class="swapa-body container-md flex-grow-1">
    <div class="row">
        <h1 id="toctop" class="col-12 col-md-auto mr-auto">{{searchContent.Heading}}</h1>
    </div>
    <div class="row">
        <div class="col-12">
            <div name="format" #format [innerHTML]="searchContent.ContentTextBody|listviewContent:searchText:filterMetadata:index:initialLoad"></div>

            <!-- Shortcut to top of page -->
            <div class="swapa-top-tocshortcut text-right text-nonselectable">
                <a class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2"
                   href="#toctop">
                    &uarr; {{searchContent.BackToTopText}}
                </a>
            </div>
        </div>
    </div>
</div>